module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAVlJREFUOE9jZMAG/tczOVw1E2P+95/rL/v/TwfUfd9gU8aILOh2cSf3P5Y/3gyMTBYMDP954HL//7/9z8iw7+9Lrv0HHB3/wMThmp1ubpZm/Mucy8jAIITVNQwMDP/+/b/3j+HrlAM6YV9AasCarW9s5OX4w1rDyMQgiEsjwhUMt/ZoefYyMDL+B2t2ubo1ioGR0QFZIxcTK7M8Ow/37e8fP/9h+PcfWe7vP4aF+3W8jjI6/N/PwnLtez8DIwM7TEG4kJJyvJiqLSsjE+vnf7+/dD2+tOfEt1evYfL/GBju7tPy6mS0u7FJke0fSyVMQoyVi32hsm0UCyMTC0zszZ8f7yNv718D4///z/hvr5ZHFqPLpa26DCyMuTAJBz4JiWppQ190v/vf3DPv27/ff2Hi35l+F1NmM0V+pii0KY5nkAFkpzBYCMLT9n9GSwYmBm6i0zZK1BCZqwDmlcrhyHJXzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/greenIcon.png
// module id = 8wq1
// module chunks = 1